import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { AirconSearchResponse } from '@brokerportal/common/models/application/aircon-reference-data.model';

@Injectable({ providedIn: 'root' })
export class AirconReferenceDataService {
    private readonly baseUrl: string;

    constructor(private httpClient: HttpClient) {
        this.baseUrl = environment.useDirectQuoteService ? environment.quoteServiceHost : environment.api.baseUrl;
    }

    searchAirConditioners(query: string, limit = 20): Observable<AirconSearchResponse> {
        const params = new HttpParams().set('search', query).set('limit', String(limit));
        return this.httpClient.get<AirconSearchResponse>(
            `${this.baseUrl}/${environment.referenceDataRoute}/air-conditioners`,
            { params }
        );
    }
}
